import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, mergeProps as _mergeProps, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_Button = _resolveComponent("Button")!
  const _component_v_spacer = _resolveComponent("v-spacer")!
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_tooltip = _resolveComponent("v-tooltip")!
  const _component_ScheduledRunCard = _resolveComponent("ScheduledRunCard")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_v_container = _resolveComponent("v-container")!

  return (_openBlock(), _createBlock(_component_v_container, {
    class: "my-0 ml-0 mr-n2 pa-0",
    fluid: ""
  }, {
    default: _withCtx(() => [
      _createVNode(_component_v_row, {
        density: "compact",
        class: "ma-0 pa-0"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_v_col, {
            cols: "12",
            class: "ma-0 pa-2"
          }, {
            default: _withCtx(() => _cache[0] || (_cache[0] = [
              _createElementVNode("p", null, "Configure agents to run on a recurring schedule. Results will be delivered via email.", -1)
            ])),
            _: 1,
            __: [0]
          })
        ]),
        _: 1
      }),
      _createVNode(_component_v_row, {
        density: "compact",
        class: "ma-0 pa-0"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_v_col, {
            cols: "12",
            density: "compact",
            class: "ma-0 pa-2 d-flex align-center"
          }, {
            default: _withCtx(() => [
              (_ctx.filteredRunIds.length > 0)
                ? (_openBlock(), _createBlock(_component_Button, {
                    key: 0,
                    buttonClass: "ml-1",
                    icon: "mdi-plus",
                    click: _ctx.addNewSchedule,
                    size: "x-large",
                    tooltip: "New Schedule",
                    variant: "outlined",
                    density: "default",
                    color: "secondary"
                  }, null, 8, ["click"]))
                : _createCommentVNode("", true),
              _createVNode(_component_v_spacer),
              _createVNode(_component_v_tooltip, {
                text: "Refresh Scheduled Runs",
                location: "top"
              }, {
                activator: _withCtx(({ props }) => [
                  _createVNode(_component_v_btn, _mergeProps(props, {
                    color: "primary",
                    variant: "text",
                    icon: "",
                    loading: _ctx.refreshingSchedules,
                    onClick: _ctx.refreshSchedules
                  }), {
                    default: _withCtx(() => [
                      _createVNode(_component_v_icon, null, {
                        default: _withCtx(() => _cache[1] || (_cache[1] = [
                          _createTextVNode("mdi-refresh")
                        ])),
                        _: 1,
                        __: [1]
                      })
                    ]),
                    _: 2
                  }, 1040, ["loading", "onClick"])
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createVNode(_component_v_row, {
        density: "compact",
        class: "ma-0 pa-0"
      }, {
        default: _withCtx(() => [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.filteredRunIds, (runId) => {
            return (_openBlock(), _createBlock(_component_v_col, {
              key: runId,
              cols: "12",
              class: "ma-0 pa-2",
              density: "compact"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_ScheduledRunCard, {
                  id: runId,
                  onRemoveCard: _ctx.removeNewScheduleCard
                }, null, 8, ["id", "onRemoveCard"])
              ]),
              _: 2
            }, 1024))
          }), 128)),
          (_ctx.count === 0)
            ? (_openBlock(), _createBlock(_component_v_col, {
                key: 0,
                cols: "12",
                md: "6",
                xl: "4",
                class: "ma-0 pa-2"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_card, {
                    onClick: _ctx.addNewSchedule,
                    class: "ma-0 pa-2 card add-card",
                    color: "surface",
                    density: "compact",
                    variant: "elevated",
                    elevation: "4",
                    "min-height": "350"
                  }, {
                    default: _withCtx(() => [
                      _cache[2] || (_cache[2] = _createElementVNode("p", null, "New Schedule", -1)),
                      _createVNode(_component_v_icon, {
                        class: "add-icon",
                        icon: "mdi-plus"
                      })
                    ]),
                    _: 1,
                    __: [2]
                  }, 8, ["onClick"])
                ]),
                _: 1
              }))
            : _createCommentVNode("", true)
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}